export interface IMarginAmount {
  MarginAmt?: number// 1645
  MiscFeeType?: string// 139
  MarginAmtCcy?: string// 1646
  MarginAmtFXRate?: number// 2088
  MarginAmtFXRateCalc?: string// 2089
  MarginAmountMarketSegmentID?: string// 1714
  MarginAmountMarketID?: string// 1715
}
